import src from "IMAGE";
export default { src, width: 1927, height: 3257, blurWidth: 0, blurHeight: 0};
